import { faQuestionCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FunctionComponent } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

interface Props {
    title: string;
    helptext: string;
    trigger?: 'hover' | 'click' | 'focus' | Array<'hover' | 'click' | 'focus'>;
}
const HelpTooltip: FunctionComponent<Props> = (props: Props) => {
    const popover = (
        <Popover id="popover-trigger" title={props.title} className="help-tooltip-popover">
            <Popover.Title>{props.title}</Popover.Title>
            <Popover.Content>
                <div dangerouslySetInnerHTML={{ __html: props.helptext }}></div>
            </Popover.Content>
        </Popover>
    );

    return (
        <>
            <OverlayTrigger rootClose={true} overlay={popover} placement="auto" trigger={props.trigger ?? 'click'}>
                <span className="question-hint no-print">
                    <FontAwesomeIcon icon={faQuestionCircle} />
                </span>
            </OverlayTrigger>
        </>
    );
};

export default HelpTooltip;
